
 

export const convertSlotsToEvents = (slots, preferredDates = []) => {

const formattedPreferredDates =  preferredDates?.map(date => {
    const [dd, mm, yyyy] = date.split("/");
    return `${yyyy}-${mm}-${dd}`;
  });

    return slots?.filter(slot => {
      // Filter OUT slots that are 'Booked' AND don't have patient_name
      const isInvalidBooked = (slot?.status === 'Booked' || slot?.status === 'Request') && !slot?.patient_name;
      return !isInvalidBooked; // Keep all other slots
    })?.map(slot => {
        const startTime = "T10:00:00";
        const endTime = "T12:00:00";
        const isPreferred = formattedPreferredDates.includes(slot?.date);
        return {
            id: `${slot?.id}`,
            title: "Slot",
            start: `${slot?.date}${startTime}`,
            end: `${slot?.date}${endTime}`,
            type: slot?.status,
            hospital_name: slot?.hospital_name,
            patient_name: slot?.patient_name,
            phase_type: slot?.phase_type,
            subject_id: slot?.subject_id,
            request_date: slot?.request_date,
            slot_alignment_id: slot?.slot_alignment_id,
            clinical_feasibility_comment: slot?.clinical_feasibility_comment,
            clinical_status: slot?.clinical_status,
            financial_feasibility_comment: slot?.financial_feasibility_comment,
            financial_status: slot?.financial_status,
            payment_type: slot?.payment_type,
            updated_at: slot?.updated_at,
            product_name: slot?.product_name,
            phase_name: slot?.phase_name,
            clinical_by_name: slot?.clinical_by_name,
            financial_by_name: slot?.financial_by_name,
            slot_alignment_reason: slot?.slot_alignment_reason,
            media: slot?.media,
            clinical_media:slot?.clinical_media,
            financial_media:slot?.financial_media,
            eventType: isPreferred ? "preferred_date" : undefined,   // <-- ADDED
        };
    }) ?.sort((a, b) => {
      // Put 'request' type slots at the top
      if (a.type?.toLowerCase() === 'request' && b.type?.toLowerCase() !== 'request') return -1;
      if (a.type?.toLowerCase() !== 'request' && b.type?.toLowerCase() === 'request') return 1;
      return 0; // Keep original order for same types
    });
}

export const convertPreferredDatesToEvents = (preferredDates) => {
    if (!preferredDates || !Array.isArray(preferredDates)) return [];

    const convertDMYtoYMD = (dateStr) => {
        const parts = dateStr.split("/");
        if (parts.length !== 3) return null;
        const [dd, mm, yyyy] = parts;
        return `${yyyy}-${mm}-${dd}`;
    };

    return preferredDates
        .map((dateItem) => {
            const startTime = "T10:00:00";
            const endTime = "T04:00:00";
            let dateString = null;
            if (typeof dateItem === "string") {
                // Convert DD-MM-YYYY → YYYY-MM-DD
                dateString = convertDMYtoYMD(dateItem);
            }
            if (!dateString) {
                console.warn("Invalid date format:", dateItem);
                return null;
            }
            return {
                title: "Slot",
                start: `${dateString}${startTime}`,
                end: `${dateString}${endTime}`,
                type: "Available",
                eventType: "preferred_date",
                originalDate: dateItem,
            };
        })
        .filter(Boolean);
};


export function sortDatesAsc(dateArray = []) {
  return [...dateArray].sort((a, b) => {
    // If any value is invalid → push it to the end safely
    if (typeof a !== "string" || typeof b !== "string") {
      return 0;
    }
    const toDate = (str) => {
      const parts = str.split("/");
      if (parts.length !== 3) return new Date(NaN);
      const [d, m, y] = parts.map(Number);
      return new Date(y, m - 1, d);
    };

    return toDate(a) - toDate(b);
  });
}